// extracted by css-extract-rspack-plugin
export default {"callButton":"GCXKiIdnX0g2SsJB"};